<template>
  <qd-message :title="$t(title)" :type="typeMessage" :closable="canClose" :has-icon="hasIcon">
    <div v-for="(message, index) in libelleList" :key="index">
      <router-link-blank v-if="message.isLink"
                         :to="{ name: message.routeName, params: { id: message.id }}"
                         :message="message.libelle">
      </router-link-blank>
      <div v-else :class="classLibelle">
        {{ message.libelle }}
      </div>
    </div>
  </qd-message>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'informationMsgComponent',
  components: {
    routerLinkBlank,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    hasIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    typeMessage: {
      type: String,
      required: false,
      default: 'is-info',
    },
    libelleList: {
      type: Array,
      required: false,
    },
    canClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    classLibelle: {
      type: String,
      required: false,
      default: 'has-text-link',
    },
  },
};
</script>

<style scoped>

</style>
